let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("cgtG8")).then(() => parcelRequire('g3qL5'));